import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';
import { DateFormats } from '@uplift/constants';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { Loader } from '../../../../Loader';
import { Button } from '../../../../Button';
import { ModalContent } from '../../../../Modal';
import { LoadableTypography } from '../../../../LoadableTypography';
import { AddendumCorrectionSectionsRenderer, SessionNoteModalBody, useClinicalNotesModal } from '../../clinical-notes-modal';
import { useAppointmentByIdQuery, useSessionByAppointmentIdQuery } from '@uplift/queries';


export type SessionDetailsNotesProps = {
  open: boolean;
  onBack: () => void;
  appointmentDateTime?: string;
  appointmentId?: string;
  correctionSections?: AddendumCorrectionSectionsRenderer;
};


export const SessionDetailsNotes: React.FC<SessionDetailsNotesProps> = (props) => {
  const l10n = useL10n();
  const timezone = useTimezone();
  const isMobile = useIsMobile();
  const { data: session } = useSessionByAppointmentIdQuery(props.appointmentId ?? '', { enabled: !!props.appointmentId });
  const { data: appointment } = useAppointmentByIdQuery(props.appointmentId ?? '', { enabled: !!props.appointmentId });
  const { state } = useClinicalNotesModal(appointment, session, props.open);

  const title = React.useMemo(() => {
    const localStartTimeStr = appointment?.fromDatetime ?? props.appointmentDateTime;
    const localStartTime = CalendarDateService.date(localStartTimeStr).tz(timezone);

    if (isMobile) {
      return (
        <>
          <Typography variant="h6">{l10n.sessions.detailsModal.progressNote}</Typography>
          <LoadableTypography variant="body2" loading={!localStartTimeStr} width="100px">{localStartTime.format(DateFormats['MMM D, YYYY'])}</LoadableTypography>
        </>
      );
    }

    return (
      <Typography variant="h6">
        {l10n.sessions.detailsModal.progressNote} (<LoadableTypography loading={!localStartTimeStr} component="span" width="82px">{localStartTime.format(DateFormats['MM/DD/YY'])}</LoadableTypography>)
      </Typography>
    );
  }, [ appointment?.fromDatetime, props.appointmentDateTime, timezone, isMobile, l10n ]);

  return (
    <>
      <Box p={2} display="flex" alignItems="center">
        <Box flex="1">
          <Button
            onClick={props.onBack}
            size="small"
            px={3}
            py={2}
            startIcon={<ArrowBackIos />}
          >
            {l10n.navigation.back}
          </Button>
        </Box>
        <Box flex="2" textAlign="center">
          {title}
        </Box>
        <Box flex="1" />
      </Box>
      <Divider />

      <ModalContent noPadding>
        {(!state || !session || !appointment) && <Loader height="500px" color="primary" />}
        {state && session && appointment && (
          <SessionNoteModalBody
            state={state}
            session={session}
            appointment={appointment}
            correctionSections={props.correctionSections}
          />
        )}
        {/* {state && state.type === AppointmentType.psychiatry && state.psychiatryNote && (
          <PsychiatryNoteModalBody
            note={state.psychiatryNote}
            // appointmentId={props.appointmentId}
            // patientId={props.patientId}
          />
        )} */}
        <Box height="16px" />
      </ModalContent>
    </>
  );
};
